export type HomeworkData = {
    id: string;
    startTime: string;
    endTime: string;
    lessonName: string;
    homeworkName: string;
    status: HomeworkStatus;
    classes: { id: string; className: string; schoolYear?: string }[];
};

export enum HomeworkStatus {
    archived = 'archived',
    started = 'started',
    ended = 'ended',
}

export type ClassModel = {
    id: string;
    school: {
        schoolName: string;
    };
    className: string;
    schoolYear?: string;
};

export type HomeworkModel = {
    id: string;
    homeworkName: string;
    lessonVersion: { id: string; lessonName: string };
    class: { id: string; className: string; schoolYear?: string }[];
    startTime: Date;
    endTime: Date;
    serverTime: Date;
    writingHints: boolean;
    freeStyleMode: boolean;
    isArchived: boolean;
};
